import React from "react";
import styled from "styled-components";

interface ITextareaProps {
  id?: string;
  value?: string | ReadonlyArray<string> | number | undefined;
  placeholder?: string;
  className?: string;
  children?: string | ReadonlyArray<string> | number | undefined;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const Textarea = (props: ITextareaProps) => {
  return (
    <TextareaSet className={props.className}>
      <textarea value={props.value} placeholder={props.placeholder} onChange={props.onChange} id={props.id} />
    </TextareaSet>
  );
};

const TextareaSet = styled.div`
  display: flex;
  padding-top: 15px;
  border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
  margin-top: 16px;
  > textarea {
    width: 100%;
    height: 100%;
    border: none;
    color: ${({ theme }) => theme.color.primary};
    font-size: 16px;
    font-family: "Roboto";
    font-weight: 500;
    resize: none;
    &::placeholder {
      color: rgba(0, 24, 39, 0.4);
      font-size: 16px;
      font-family: "Roboto";
      font-weight: 500;
    }
    &:focus {
      outline: none;
    }
  }
`;

export default Textarea;
